/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { auctionsbooking } from "../../../actions/formAction";
import { CircularProgress } from '@mui/material';
import { t } from 'i18next';
import { isArray } from 'lodash';

function BookingMenu() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [selectedBookingNumbers, setSelectedBookingNumbers] = useState([]);
    const [anchor, setAnchor] = useState(null);
    const open = Boolean(anchor);
    const [mainData, setMainData] = useState([]);
    const [debouncedInputValue, setDebouncedInputValue] = useState('');
    const [input, setInput] = useState('');



    const formReducer = useSelector((state) => state.form);

    useEffect(() => {
        if (formReducer.isLoadingContainerData === 'succeeded') {
            const newData = formReducer.booking;
            const  addedList = newData.filter(item2 => !mainData.some(item1 => item1.id === item2.id));

            if (addedList) {
                setMainData(prevData => [...prevData, ...addedList]);
            }
        }
        const searchParams = new URLSearchParams(location.search);
        const BookingParam = searchParams.get('Booking');

        if (BookingParam === null) {
            setSelectedBookingNumbers([]);
        } else {
            const selectedTypes = BookingParam.split(',').map(Number);
            setSelectedBookingNumbers(selectedTypes);
        }
    }, [formReducer.isLoadingBookingData, location.search]);

    useEffect(() => {
        updateURLQuery();
    }, [selectedBookingNumbers]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            dispatch(auctionsbooking({ name: input }));
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [debouncedInputValue, dispatch]);

    const updateURLQuery = () => {
        if (anchor) {
            const searchParams = new URLSearchParams(location.search);
            if (selectedBookingNumbers.length === 0) {
                searchParams.delete('Booking');
            } else {
                searchParams.set('Booking', selectedBookingNumbers.join(','));
            }
            navigate({ search: searchParams.toString() });
        }
    };

    const handleAutocompleteChange = (event, value) => {
        setSelectedBookingNumbers(value.map((item) => item.id));
    };

    const handleClick = (event) => {
        setAnchor(event.currentTarget);
    };

    const handleClose = () => {
        setAnchor(null);
    };

   

    return (
        <Box className="BookingNumber">
            <Button
                id="BookingNumber"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                Booking 
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Button>

            <Menu
                id="basic-menu"
                anchorEl={anchor}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'BookingNumber',
                }}
                PaperProps={{
                    style: {
                        width: '25%',
                        maxWidth: '100%',
                        maxHeight: '300px',
                        left: 0,
                        right: 0,
                    },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexWrap: 'wrap',
                        width: '100%',
                        maxHeight: '300px',
                        overflow: 'auto',
                        overflowY: 'hidden',
                        p: 2
                    }}
                >
                    <Autocomplete
                        multiple
                        id="booking-autocomplete"
                        options={mainData}
                        value={selectedBookingNumbers.map(id => isArray(mainData) ? mainData?.find(item => item.id === id) || null :[])}
                        onChange={handleAutocompleteChange}
                        inputValue={input}
                        onInputChange={(event, value) => {
                            // Update the input value immediately without debouncing

                         setDebouncedInputValue(value);
                        }}
                        clearText="Clear"

                        disableCloseOnSelect
                        getOptionLabel={(option) => option?.number}
                        loading={formReducer.isLoadingBookingData === 'pending'}

                        renderInput={(params) => <TextField {...params} label={`#${t('bookingNumber')}`} onChange={({ target }) => setInput(target.value)} InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {formReducer.isLoadingBookingData === 'pending' ? <CircularProgress color="error" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }} />}








                    />

                </Box>
            </Menu>
        </Box>
    );
}

export default BookingMenu;
